import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const cmsPrefilteredTravelsBlockEntity: Entity = {
  model: model,
  repository: repository,
}

export default cmsPrefilteredTravelsBlockEntity
